export default __webpack_public_path__ + "static/media/stealth_modeMobile.d20c9029.png";